import React, { Component } from 'react';
import './styles.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHourglassHalf, faHourglassEnd } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import NavigateBack from 'src/Components/NavigateBack/NavigateBack';
import SubscriptionLoader from 'src/Components/SubscriptionLoader/SubscriptionLoader';
import { withTranslation } from 'react-i18next';

class Subscription extends Component {
  state = {}

  setErrorMessage = (message, text, color) => {
    const { t } = this.props;
    if(text === 'expired'){
      text = t(text);
    }
    let a = new RegExp(text, "gi");
    let b = new RegExp(t('contactGE'), "i");
    const formattedStr = message.replace(
      a,
      changedText => `<span style="font-weight: bold">${changedText}</span>`
    ).replace(b, anotherText => `<a href="https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert" target="_blank" style=color:#51BDDF;text-decoration:none>${anotherText}</a>`);
    return <span dangerouslySetInnerHTML={{ __html: formattedStr }} />;
  }

  navigateBack = () => {
    this.props.displayComponent(false, 'subscription')
  }


  selectColorSubAndEd = (sub, value) => {
    const { t } = this.props;
    let result;
    if (value === 'COLOR') {
      result = (sub.status === 'Expired') ? '#DF4661' : '#F48A3A';
    } else {
      result = (sub.packageName === 'EDUCATION') ? `${t('DELearning')}: ` : `${t('DEConnect')}: `
    }
    return result
  }

  selectSubscriptionIcon=(sub)=>{
    const result = (sub.status === 'Expired') ? faHourglassEnd : faHourglassHalf;
    return result;
  }

  render() {
    const { subscriptionList, isLoading } = this.props.subscription;
    const { t } = this.props;
    return (
      <>
        {isLoading ?
          <div className="subscription-container-loader">
            <div className="subscription-tag">
              <span className="nav-back-wrapper">
                <NavigateBack text={t('back')} onClick={this.navigateBack} />
              </span>
            </div>
            <SubscriptionLoader />
          </div> :
          <div className="subscription-wrapper">
            <div className="subscription-header-wrapper">
              <div className="subscription-tag">
                <span className="nav-back-wrapper">
                  <NavigateBack text={t('back')} onClick={this.navigateBack} />
                </span>
              </div>
            </div>
            <div className="subscription-title-block">
              <div className="subscription-title">{t('subscription')}</div>
            </div>
            <>
              <p className="contact-us-wrapper"><a href="https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert" target="_blank" className="contact-us-link">{t('contactUsPrefix')}</a></p>
              {subscriptionList && subscriptionList.length > 0 && subscriptionList.map((item, i) => {

                return (
                  <div key={item.facilityName} className="subscription-parent-block">
                    <div className="subscription-metrics-container">
                      <p className="subscription-title">{item.facilityName}</p>
                      <p className="subscription-address">{item.street}</p>
                      <p className="subscription-address">{`${item.city}, ${item.state}, ${item.postalCode} ${item.country}`}</p>
                      {item.onyxSubscriptionDetails && item.onyxSubscriptionDetails.length > 0 && item.onyxSubscriptionDetails.map((sub, j) => {
                        let color = this.selectColorSubAndEd(sub, 'COLOR');
                        let subscriptionStatus = this.selectSubscriptionIcon(sub);
                        return (
                          <>
                            {sub.packageName !== 'ADHOC' &&
                              <React.Fragment>
                                <div className="subscription-package-details">
                                  <span className="subscription-package-name">{this.selectColorSubAndEd(sub, 'EDUCATION')} </span>{item.formattedMod.join(', ')}</div>
                                <div className="subscription-date">{t('expires')} {moment(sub.endDate).format('MMMM D, YYYY')}</div>
                                {sub.status ?
                                  <div className="subscription-error-container">
                                    <p className="error-message" style={{ color: color }}>
                                      <FontAwesomeIcon icon={subscriptionStatus} color={color} />
                                      {this.setErrorMessage(sub.errorMessage, sub.text, color)}
                                    </p>
                                  </div>
                                  : null}
                              </React.Fragment>
                            }
                          </>
                        )
                      })}
                    </div>
                    <hr className="separator" />
                  </div>
                )
              })}
            </>
          </div>
        }
      </>
    );
  }
}

export default withTranslation()(Subscription);